/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, string, bool } from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';

import { getDataDictionary } from '../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';

class BackButton extends React.Component {
    goToPreviousPage = (url = '') => {
        const { history, location: { pathname } } = this.props;
        if (url) {
            history.push(url);
        } else {
            const paths = pathname.replace(/(^\/|\/$)/g, '').split('/');
            paths.pop();
            if (paths.length > 0) {
                const prevURL = ''.concat('/', paths.join('/'));
                history.push(prevURL);
            }
        }
    };

    render() {
        const {
            url, desktopButton, desktopHDButton, desktopOrderButton, dataDictionary,
        } = this.props;
        if (desktopButton) {
            return (
                <Button
                    className="back-link"
                    onClick={() => this.goToPreviousPage(url)}
                >
                    &#60; {
                        getLanguageName() === '/en' ? 'Back to My Orders' : dataDictionary?.['Back to My Orders'] || 'Back to My Orders'
                    }
                </Button>
            );
        }
        if (desktopHDButton) {
            return (
                <Button
                    className="secondary"
                    onClick={() => this.goToPreviousPage(url)}
                >
                    <KeyboardArrowLeft />
                    {
                        getLanguageName() === '/en' ? 'Back to My Orders' : dataDictionary?.['Back to My Orders'] || 'Back to My Orders'
                    }
                </Button>
            );
        }

        if (desktopOrderButton) {
            return (
                <>
                    <ArrowBackIosIcon />
                    <Button
                        onClick={() => this.goToPreviousPage(url)}
                    >
                        {
                            getLanguageName() === '/en' ? 'TRACK ANOTHER ORDER' : dataDictionary?.['TRACK ANOTHER ORDER'] || 'TRACK ANOTHER ORDER'
                        }
                    </Button>
                </>
            );
        }
        return (
            <Button
                className="back-arrow-button"
                onClick={() => this.goToPreviousPage(url)}
            >
                <ArrowBack />
            </Button>
        );
    }
}

BackButton.defaultProps = {
    url: '',
    desktopButton: false,
    desktopHDButton: false,
    desktopOrderButton: false,
    dataDictionary: {},
};

BackButton.propTypes = {
    history: object.isRequired,
    location: object.isRequired,
    url: string,
    desktopButton: bool,
    desktopHDButton: bool,
    desktopOrderButton: bool,
    dataDictionary: object,
};

const mapStateToProps = (state) => ({
    dataDictionary: getDataDictionary(state),
});

export default connect(mapStateToProps)(withRouter(BackButton));
